var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 36,
    viewBox: "0 0 20 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0V36",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 35.0005C9.99998 29.4776 5.52284 25.0005 0 25.0005",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 35C10 29.4771 14.4772 25 20 25",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.17680a714eb307a63674510f0d4134cc.svg";
export { ForwardRef as ReactComponent };